<template>
  <div>
    <v-alert
      text
      color="info"
      type="info"
      prominent
      class="text-center"
    >
      <h3 class="headline mr-10 pr-5" v-text="tokenBalanceMessage" />
    </v-alert>

    <tokens-history-list
      :value="historyList"
      :company-id="company.id"
      :loading="loadingData"
      :search="search"
    />

    <!-- RouterView for modals -->
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import TokensHistoryList from 'src/modules/token/components/TokensHistoryList'

export default {
  name: 'CompanyHistoryContainer',
  components: {
    TokensHistoryList,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    search: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    historyList: [],
    loadingData: false,
  }),
  computed: {
    tokenBalanceMessage () {
      const balance = this.company.tokenBalance // TODO: fdgfdg
      return this.$tc('tokens.balance', balance, { balance })
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'CompanyHistory') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      this.loadingData = true
      this.historyList = await Repositories.company.getTokensHistory(this.company.id)
      this.loadingData = false
    },
  },
}
</script>
